import { getSrcs } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import * as React from 'react';
import S from './CategoryCard.styles';
const CategoryCard = (props) => {
    const srcsMobile = props.image ? getSrcs(props.image, 702, 250, 6, 1) : [];
    const srcs = props.image ? getSrcs(props.image, 1036, 702, 6, 454 / 836) : [];
    return (React.createElement(S.Container, { ...(props.cta?.url
            ? {
                as: 'a',
                href: props.cta.url,
                title: props.cta.text,
                target: props.cta.target,
            }
            : {}) },
        props.image && (React.createElement(S.ImageWrapper, null,
            React.createElement("picture", null,
                React.createElement("source", { srcSet: srcs.join(','), media: from(Device.Tablet), sizes: `${until(Device.DesktopLarge)} 25vw, 601px` }),
                React.createElement(S.Image, { src: srcsMobile[0].split(' ')[0], srcSet: srcsMobile.join(','), role: !props.image.altText ? 'presentation' : undefined, loading: "lazy", sizes: "50vw", alt: props.image.altText })))),
        React.createElement(S.TitleWrapper, null,
            React.createElement(S.Title, null, props.title))));
};
export default CategoryCard;
